import { request } from '@vtx/utils';
import { useEffect } from 'react';
import { useState } from 'react';

const getRoleCode = async (urlHead) => {
    const data = await request.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/common/listUserBindRoleCode`);
    if (!!data && !data.result) {
        return data?.data || [];
    }
};

export default (urlHead) => {
    const [roleCode, setRoleCode] = useState([]);
    useEffect(() => {
        getRoleCode(urlHead).then(data => {
            setRoleCode(data);
        });
    }, []);

    return { roleCode };
};
